<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ data.title }}</h2>
      <p class="app-dialog__subtitle" *ngIf="data.subtitle">{{ data.subtitle }}</p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body print-card-order-item-preview-dialog__content">
    <div
      *ngIf="isPdfPreview"
      class="print-card-order-item-preview-dialog__pdf"
    >
      <div
        *ngIf="loading"
        class="print-card-order-item-preview-dialog__loader"
      ></div>
      <iframe
        *ngIf="!loading && pdfUrl"
        class="print-card-order-item-preview-dialog__pdf-frame"
        [src]="pdfUrl"
        title="{{ data.title }}"
      ></iframe>
    </div>
    <app-print-card-preview
      *ngIf="!isPdfPreview"
      [frontDocumentHtml]="frontDocumentHtml"
      [backDocumentHtml]="backDocumentHtml"
      [loading]="loading"
      [pageWidthCm]="pageWidthCm"
      [pageHeightCm]="pageHeightCm"
    ></app-print-card-preview>
  </div>

  <footer class="app-dialog__footer">
    <button mat-raised-button color="primary" type="button" (click)="close()">
      {{ "close" | translate }}
    </button>
  </footer>
</div>
